export enum InformationBarType {
    Success,
    Error,
    Info,
    Warning
}